import { FC, PropsWithChildren, useEffect } from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { getDatePickerLocaleText, getDayjsLocale, syncDayjsLocale } from './formatting';
import { useAppLocale } from './useAppLocale';

const LocalizedDateProvider: FC<PropsWithChildren> = ({ children }) => {
  const locale = useAppLocale();

  useEffect(() => {
    syncDayjsLocale(locale);
  }, [locale]);

  return (
    <LocalizationProvider
      dateAdapter={AdapterDayjs}
      adapterLocale={getDayjsLocale(locale)}
      localeText={getDatePickerLocaleText(locale)}
    >
      {children}
    </LocalizationProvider>
  );
};

export default LocalizedDateProvider;
